"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterStreams = exports.epochM = void 0;
const rxjs_1 = require("rxjs");
const pipes_1 = require("@neurosity/pipes");
const neurosity_utils_1 = require("./neurosity-utils");
function epochM({ interval, duration, channelNames, samplingRate, packetThreshold }) {
    return rxjs_1.pipe(pipes_1.addInfo({ channelNames: channelNames, bufferInterval: interval, bufferDuration: duration }), neurosity_utils_1.epoch({
        samplingRate: samplingRate,
        interval: interval,
        duration: duration,
        packetThreshold: packetThreshold,
    }), 
    // TODO: voltsToMicrovolts ?
    pipes_1.addSignalQuality());
}
exports.epochM = epochM;
function filterStreams({ nbChannels, samplingRate, cutoffFrequencies }) {
    return rxjs_1.pipe(pipes_1.notchFilter({
        nbChannels: nbChannels,
        cutoffFrequency: 50,
        filterHarmonics: true,
        samplingRate: samplingRate,
    }), pipes_1.bandpassFilter({
        cutoffFrequencies: cutoffFrequencies,
        nbChannels: nbChannels,
        samplingRate: samplingRate,
    }));
}
exports.filterStreams = filterStreams;
//# sourceMappingURL=epoch.js.map